
import React from 'react';
import { Presentation, Package, CheckCircle2 } from 'lucide-react';
import { LocalizedContent } from '../utils/localization';

interface BenefitsProps {
  content: LocalizedContent;
}

const Benefits: React.FC<BenefitsProps> = ({ content }) => {
  const benefits = [
    {
      title: "Zeit sparen",
      description: "Erhalten Sie fertige Videos innerhalb weniger Tage statt Wochen.",
      icon: <Presentation className="text-purple-400" size={36} />
    },
    {
      title: "Kosten reduzieren",
      description: "Bis zu 70% günstiger als herkömmliche Videoproduktionen.",
      icon: <Package className="text-purple-400" size={36} />
    },
    {
      title: "Conversions steigern",
      description: "Durchschnittlich 40% mehr Käufe durch überzeugende Produktvideos.",
      icon: <CheckCircle2 className="text-purple-400" size={36} />
    }
  ];

  return (
    <section className="py-16 bg-[#0D0D12]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-white font-future">{content.benefitsTitle}</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-[#15151D] p-6 rounded-lg border border-purple-900/20 hover:border-purple-500/30 transition-colors">
                <div className="mb-4">{benefit.icon}</div>
                <h3 className="text-xl font-semibold mb-2 text-white">{benefit.title}</h3>
                <p className="text-gray-400">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
